// @flow

//
// React
//
import React from 'react';

//
// Formatter
//
import {
    fmtMoney,
    type Money,
} from '../../../../trix-web-data-commons';

//
// Components
//
import FloatPaneField from './FloatPaneField';

//
// Props
//
type Props = {
    //
    // State
    //
    fmt?: string,
    label: string,

    //
    // Data
    //
    value: Money,

    //
    // Actions
    //
    onClick?: () => void;
}; // End of Props

//
// Component
//
const MoneyFloatPaneField = (props: Props): any => {
    const value = fmtMoney(props.value);

    return (
        <FloatPaneField
            label={props.label}
            value={value}
            onClick={props.onClick}
        />
    );
};
export default MoneyFloatPaneField;
